import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BellRing, Mail, ChevronRight } from "lucide-react";
import { gapi, errMsg, fmtDateTime } from "../api";
import { useGAuth } from "../GAuth";
import { PageHeader, Panel, Btn, Badge } from "../components/ui";

const TIPI = { contatto_non_gestito: "Contatti non gestiti", richiamo: "Richiami", attivita_scaduta: "Attività scadute", incarico_scadenza: "Incarichi",
  locazione_scadenza: "Contratti in scadenza", canone_arretrato: "Canoni arretrati", manutenzione: "Manutenzioni" };

function DigestBox() {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { gapi.get("/settings/digest").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg) return null;
  const toggle = async () => setCfg((await gapi.put("/settings/digest", { attivo: !cfg.attivo })).data);
  const sendNow = async () => {
    setBusy(true);
    try { const { data } = await gapi.post("/alerts/digest-now"); toast[data.inviata ? "success" : "error"](data.inviata ? `Riepilogo inviato (${data.avvisi} avvisi)` : "Invio non riuscito"); setCfg((await gapi.get("/settings/digest")).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Panel title="Email riepilogativa giornaliera" testid="digest-box">
      <p className="text-sm text-anthracite/60 mb-3">Inviata al titolare {cfg.orario}. Ultimo invio: {cfg.ultimoInvio ? fmtDateTime(cfg.ultimoInvio) : "mai"}.</p>
      <div className="flex flex-wrap gap-2">
        <Btn variant={cfg.attivo ? "ghost" : "primary"} onClick={toggle} data-testid="digest-toggle">{cfg.attivo ? "Disattiva riepilogo" : "Attiva riepilogo"}</Btn>
        <Btn variant="ghost" onClick={sendNow} disabled={busy} data-testid="digest-send-now"><Mail className="h-4 w-4" /> Invia ora</Btn>
      </div>
      <p className="text-xs mt-2" data-testid="digest-status">Stato: <b>{cfg.attivo ? "attivo" : "disattivato"}</b></p>
    </Panel>
  );
}

export default function Avvisi() {
  const { user } = useGAuth();
  const [data, setData] = useState(null);
  const [tipo, setTipo] = useState("");
  useEffect(() => { gapi.get("/alerts").then((r) => setData(r.data)); }, []);
  const items = (data?.items || []).filter((a) => !tipo || a.tipo === tipo);
  const counts = (data?.items || []).reduce((m, a) => ({ ...m, [a.tipo]: (m[a.tipo] || 0) + 1 }), {});
  return (
    <div data-testid="g-alerts-page">
      <PageHeader eyebrow="Automazioni" title="Avvisi" desc="Promemoria calcolati in automatico: nuovi contatti da gestire, richiami, scadenze di incarichi e contratti, canoni non incassati, manutenzioni urgenti." />
      <div className="grid lg:grid-cols-[1fr_340px] gap-4 items-start">
        <Panel testid="alerts-list">
          <div className="flex flex-wrap gap-1.5 mb-4">
            <button onClick={() => setTipo("")} className={`rounded-full px-3 py-1.5 text-xs font-semibold border ${!tipo ? "bg-brand text-white border-brand" : "bg-white border-border-subtle"}`} data-testid="alerts-filter-all">Tutti ({data?.totale ?? 0})</button>
            {Object.entries(counts).map(([k, n]) => <button key={k} onClick={() => setTipo(k)} className={`rounded-full px-3 py-1.5 text-xs font-semibold border ${tipo === k ? "bg-brand text-white border-brand" : "bg-white border-border-subtle"}`} data-testid={`alerts-filter-${k}`}>{TIPI[k]} ({n})</button>)}
          </div>
          <ul className="divide-y divide-border-subtle">{items.map((a, i) => (
            <li key={i}><Link to={a.link} className="py-3 flex items-center gap-3 text-sm hover:bg-accent-subtle/40 rounded-lg px-2" data-testid="alert-row">
              <BellRing className={`h-4 w-4 shrink-0 ${a.gravita === "alta" ? "text-red-600" : "text-amber-600"}`} />
              <span className="flex-1"><b>{a.titolo}</b><br /><span className="text-xs text-anthracite/55">{a.testo}</span></span>
              <Badge tone={a.gravita === "alta" ? "red" : "amber"}>{a.gravita === "alta" ? "Prioritario" : "Da fare"}</Badge><ChevronRight className="h-4 w-4 text-anthracite/30" /></Link></li>))}
            {data && !items.length && <li className="py-6 text-sm text-anthracite/45" data-testid="alerts-empty">Nessun avviso: tutto in ordine.</li>}
          </ul>
        </Panel>
        {user.ruolo === "titolare" && <DigestBox />}
      </div>
    </div>
  );
}
